import {
  UsageExplorerTopItem,
  UsageGroupByType,
  UsageType,
} from "@shared/types/localTypes/usage-explorer.ts";
import apiProxy from "@shared/utils/api-proxy.ts";
import { GranularityType } from "@shared/types/localTypes/common.ts";

export interface FetchUsageFiltersRequest {
  nonce: string;
  subscription: number;
  start_date: string;
  end_date: string;
  partition_by: GranularityType;
  filter_key: UsageGroupByType;
  filter_key_value_prefix: string;
  filter_by?: Partial<Record<UsageGroupByType, string[]>>;
  limit: number;
}

export interface FetchUsageFiltersResponse {
  nonce: string;
  top: UsageExplorerTopItem[];
}

export default async (arg: {
  request: FetchUsageFiltersRequest;
  usageType: UsageType;
}) => {
  const { request, usageType } = arg;

  const response: FetchUsageFiltersResponse | null = await apiProxy.post(
    `usage-explorer/get-usage-filters/${usageType}`,
    request,
  );

  if (!response) {
    throw new Error("Got no response from server");
  }
  return response;
};
